module.exports = __webpack_public_path__ + "static/media/bmw_zertifikat_2012.83514efc.jpg";